"use strict";
var $ = require("../internals/export");
var from = require("../internals/array-from");
var checkCorrectnessOfIteration = require("../internals/check-correctness-of-iteration");
var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
  Array.from(iterable);
});
$({ target: "Array", stat: true, forced: INCORRECT_ITERATION }, {
  from
});
